import type { FC, ReactNode } from 'react';

import styles from './SettingsItem.module.css';
import TransWithFallback from 'shared/components/Translations/TransWrapper';

type SettingsItemProps = {
  labelKey: string;
  descriptionKey: string;
  icon: ReactNode;
  children: ReactNode;
  labelTestId?: string;
  descriptionTestId?: string;
};

const SettingsItem: FC<SettingsItemProps> = ({ labelKey, descriptionKey, icon, children, labelTestId, descriptionTestId }) => {
  return (
    <div className={styles.settingItem}>
      <div className={styles.settingIcon}>
        {icon}
      </div>
      <div className={styles.settingsText}>
        <div className={styles.label} data-testid={labelTestId}>{TransWithFallback({ i18nKey: labelKey })}</div>
        <div className={styles.description} data-testid={descriptionTestId}>{TransWithFallback({ i18nKey: descriptionKey })}</div>
      </div>
      <div className={styles.settingValue}>{children}</div>
    </div>
  );
};

export default SettingsItem;
